import { render, staticRenderFns } from "./MsotList.vue?vue&type=template&id=52595cb6&scoped=true&"
import script from "./MsotList.vue?vue&type=script&lang=js&"
export * from "./MsotList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52595cb6",
  null
  
)

export default component.exports